export const ATTENDEE_RSVP_STATUS = {
  ALL: "ALL",
  ATTENDING: "ATTENDING",
  PENDING: "PENDING",
  DECLINED: "DECLINED",
  HOST_APPROVAL_REQUESTED: "HOST_APPROVAL_REQUESTED",
}